/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type FolderWrapper_viewer$ref = any;
export type FolderWrapperWrapper_viewer$ref = any;
export type FolderWrapperWrapper_viewer = {
    readonly id: string;
    readonly " $fragmentRefs": FolderWrapper_viewer$ref;
    readonly " $refType": FolderWrapperWrapper_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "FolderWrapperWrapper_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "LocalArgument",
            "name": "selectedItemIds",
            "type": "[String]",
            "defaultValue": []
        },
        {
            "kind": "LocalArgument",
            "name": "shouldFillInFolder",
            "type": "Boolean",
            "defaultValue": false
        },
        {
            "kind": "LocalArgument",
            "name": "userIds",
            "type": "[String]",
            "defaultValue": []
        }
    ],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "FolderWrapper_viewer",
            "args": [
                {
                    "kind": "Variable",
                    "name": "selectedItemIds",
                    "variableName": "selectedItemIds"
                },
                {
                    "kind": "Variable",
                    "name": "shouldFillInFolder",
                    "variableName": "shouldFillInFolder"
                },
                {
                    "kind": "Variable",
                    "name": "userIds",
                    "variableName": "userIds"
                }
            ]
        }
    ]
} as any);
(node as any).hash = '366f7e74d597f4569f6a44f1637f2ecd';
export default node;
